import { render, staticRenderFns } from "./ResourcesTable.vue?vue&type=template&id=a773a030&scoped=true&"
import script from "./ResourcesTable.vue?vue&type=script&lang=js&"
export * from "./ResourcesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a773a030",
  null
  
)

export default component.exports